import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TotalTimeIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function TotalTimeIcon({ color = RoutalPalette.secondary20, style = {}, ...props }: TotalTimeIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12" style={{ height: `14px`, width: `14px`, ...style }}>
      <g>
        <path
          d="M6.00003 11.1429C8.84036 11.1429 11.1429 8.84033 11.1429 6C11.1429 3.15968 8.84036 0.857147 6.00003 0.857147C3.15971 0.857147 0.857178 3.15968 0.857178 6C0.857178 8.84033 3.15971 11.1429 6.00003 11.1429Z"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 2.91428V5.99999L8.05714 7.02856"
          stroke={RoutalPalette.neutral00}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </SvgIcon>
  );
}
